// Social link configuration
const facebookLinkConfig = {
  defaults: 'https://www.facebook.com/Stubhub/',
  2: 'https://www.facebook.com/StubHubUK/',
  3: 'https://www.facebook.com/StubHubDeutschland/?fref=ts/',
  4: 'https://www.facebook.com/StubHubUK/',
  7: 'https://www.facebook.com/StubHubUK/',
  6: 'https://www.facebook.com/StubHubEspana/',
  8: 'https://www.facebook.com/StubHubCanada/',
  10: 'https://www.facebook.com/StubHubItalia/',
  11: 'https://www.facebook.com/StubHubnederland',
  12: 'https://www.facebook.com/StubHubDeutschland/?fref=ts/',
  13: {
    'fr-BE': 'https://www.facebook.com/StubHubUK/',
  },
  14: 'https://www.facebook.com/StubHubUK/',
  16: {
    'fr-LU': 'https://www.facebook.com/StubHubUK/',
    'de-LU': 'https://www.facebook.com/StubHubDeutschland/?fref=ts/',
  },
};

const twitterLinkConfig = {
  defaults: 'https://twitter.com/StubHub/',
  2: 'https://twitter.com/stubhubuk/',
  3: 'https://twitter.com/stubhubde/',
  4: 'https://twitter.com/stubhubuk/',
  6: 'https://twitter.com/StubHubes',
  7: 'https://twitter.com/StubHubUK?lang=en',
  8: 'https://twitter.com/stubhubca/',
  10: 'https://twitter.com/StubHubit',
  11: 'https://twitter.com/StubHubnl',
  12: 'https://twitter.com/stubhubde/',
  13: {
    'fr-BE': 'https://twitter.com/stubhubuk/',
  },
  14: 'https://twitter.com/stubhubuk/',
  16: {
    'de-LU': 'https://twitter.com/stubhubde/',
    'fr-LU': 'https://twitter.com/stubhubuk/',
  },
};

const instagramLinkConfig = {
  defaults: 'https://www.instagram.com/stubhub/',
  2: 'https://www.instagram.com/stubhubuk/',
  3: 'https://www.instagram.com/stubhubde/',
  4: 'https://www.instagram.com/stubhubuk/',
  6: 'https://www.instagram.com/stubhubes/',
  7: 'https://www.instagram.com/stubhubuk/',
  8: 'https://www.instagram.com/stubhubca/',
  10: 'https://www.instagram.com/stubhubit/',
  11: 'https://www.instagram.com/stubhubnl/',
  12: 'https://www.instagram.com/stubhubde/',
  13: {
    'fr-BE': 'https://www.instagram.com/stubhubuk/',
  },
  14: 'https://www.instagram.com/stubhubuk/',
  16: {
    'de-LU': 'https://www.instagram.com/stubhubde/',
    'fr-LU': 'https://www.instagram.com/stubhubuk/',
  },
};

const getLinkByConfig = (storeId, locale, config) => {
  /* istanbul ignore next */
  const storeConfig = config[storeId] || config.defaults || '';

  return storeConfig[locale] || storeConfig;
};

const getSocialLink = (storeId, locale) => {
  return {
    facebook: getLinkByConfig(storeId, locale, facebookLinkConfig),
    twitter: getLinkByConfig(storeId, locale, twitterLinkConfig),
    instagram: getLinkByConfig(storeId, locale, instagramLinkConfig),
    linkedin: 'https://www.linkedin.com/company/stubhub-international/',
  };
};

// App download link configuration
const androidDownloadLinkConfig = {
  defaults: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=gb',
  1: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub',
  2: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=gb',
  3: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=de',
  4: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=fr',
  5: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=mx',
  6: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=es',
  7: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=pt',
  8: {
    'en-CA': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&hl=en_CA',
    'fr-CA': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&hl=fr_CA',
  },
  9: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=cz',
  10: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=it',
  11: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=nl',
  12: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=at',
  13: {
    'fr-BE': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=be&hl=fr',
    'nl-BE': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=be',
  },
  14: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=ie',
  15: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=fi',
  16: {
    'fr-LU': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=lu',
    'de-LU': 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=lu&hl=de',
  },
  17: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=gr',
  18: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=pl',
  19: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=se',
  20: 'https://play.google.com/store/apps/details?id=com.ticketbis.stubhub&gl=dk',
};

const iosDownloadLinkConfig = {
  defaults: 'https://apps.apple.com/gb/app/id1558671441',
  1: 'https://apps.apple.com/app/stubhub-buy-and-sell-tickets/id1558671441',
  2: 'https://apps.apple.com/gb/app/id1558671441',
  3: 'https://apps.apple.com/de/app/id1558671441',
  4: 'https://apps.apple.com/fr/app/id1558671441',
  5: 'https://apps.apple.com/mx/app/id1558671441',
  6: 'https://apps.apple.com/es/app/id1558671441',
  7: 'https://apps.apple.com/pt/app/id1558671441',
  8: 'https://itunes.apple.com/ca/app/stubhub-buy-and-sell-tickets/id1558671441?mt=8',
  9: 'https://apps.apple.com/cz/app/id1558671441',
  10: 'https://apps.apple.com/it/app/id1558671441',
  11: 'https://apps.apple.com/nl/app/id1558671441',
  12: 'https://apps.apple.com/at/app/id1558671441',
  13: 'https://apps.apple.com/be/app/id1558671441',
  14: 'https://apps.apple.com/ie/app/id1558671441',
  15: 'https://apps.apple.com/fi/app/id1558671441',
  16: 'https://apps.apple.com/lu/app/id1558671441',
  17: 'https://apps.apple.com/gr/app/id1558671441',
  18: 'https://apps.apple.com/pl/app/id1558671441',
  19: 'https://apps.apple.com/se/app/id1558671441',
  20: 'https://apps.apple.com/dk/app/id1558671441',
};

const getAppDownloadLink = (storeId, locale) => {
  return {
    android: getLinkByConfig(storeId, locale, androidDownloadLinkConfig),
    ios: getLinkByConfig(storeId, locale, iosDownloadLinkConfig),
  };
};

export {getAppDownloadLink, getSocialLink};
